import { z } from "zod";
import { linkTokenHashSchema } from "./linkTokenHashSchema";

export const GetMagicLinkDataInputSchema = z.object({
    linkTokenHash: linkTokenHashSchema,
});

export type GetMagicLinkDataInput = z.infer<typeof GetMagicLinkDataInputSchema>;
